import { useHistory } from 'react-router-dom'
import { Block, Button, Text } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const CTABlock = (): JSX.Element => {
  const history = useHistory()

  return (
    <CTAButtonContainer>
      <CTAButton
        //@ts-expect-error
        text='Sign up free'
        onClick={() => history.push('/signup')}
      />
      <Text
        tag='small'
        alignment='center'
        fontSize={14}
        fontWeight={400}
        color='grey.d2'
      >
        No card required
      </Text>
    </CTAButtonContainer>
  )
}

const CTAButtonContainer = styled(Block).attrs({
  gap: 12,
  width: 'max-content'
})`
  margin-top: 26px;

  @media (max-width: 479px) {
    margin-top: 10px;
  }
`

const CTAButton = styled(Button)`
  height: 54px;
  padding: 0 28px;

  & .button-text {
    font-size: 18px;
  }
`
